import { ExternalLinkIcon } from "lucide-react";

export default function PrivacyPolicies() {
  return (
    <div className="sm:mt-36 p-5 mt-16 mb-16 flex flex-col gap-10">
      <h1 className="font-montserrat font-medium text-xl sm:text-2xl capitalize">
        Privacy Policies
      </h1>
      <div className="flex flex-col gap-10">
        <div className="flex flex-col gap-5">
          <h3 className="font-bold">Introduction</h3>
          <p className="sm:text-md text-sm">
            This Privacy Policy explains how we collect,
            use, and protect your personal information when
            you visit or make a purchase from
            amadeussabra.com.
          </p>
        </div>
        <div className="flex flex-col gap-5">
          <h3 className="font-bold">
            What Information We Collect
          </h3>
          <div className="flex flex-col gap-3">
            <p className="sm:text-md text-sm">
              When you visit our website, we automatically
              collect certain information about your device,
              including:
            </p>
            <ul className="flex gap-2 flex-col pl-5">
              <li className="sm:text-md text-sm">
                - Your web browser, IP address, time zone,
                and cookies from your device.
              </li>
              <li className="sm:text-md text-sm">
                - Pages you view, websites that referred you
                to us, and how you interact with our site.
                We call this “Device Information”.
              </li>
              <li className="sm:text-md text-sm">
                - When you make a purchase, we collect your
                name, billing and shipping address, email
                address, and phone number. We call this
                “Order Information”.
              </li>
            </ul>
          </div>{" "}
        </div>
        <div className="flex flex-col gap-5">
          <h3 className="font-bold">
            How We Use Your Information
          </h3>
          <div className="flex flex-col gap-3">
            <p className="sm:text-md text-sm">
              We use your Order Information to:
            </p>
            <ul className="flex gap-2 flex-col pl-5">
              <li className="sm:text-md text-sm">
                - Process your payments and fulfill your
                orders.
              </li>
              <li className="sm:text-md text-sm">
                - Communicate with you about your order.
              </li>
              <li className="sm:text-md text-sm">
                - Screen for potential fraud or risk.
              </li>
              <li className="sm:text-md text-sm">
                - Send you information or ads about our
                products (if you've agreed to this).
              </li>
            </ul>
          </div>
          <div className="flex flex-col gap-3">
            <p className="sm:text-md text-sm">
              {" "}
              We use your Device Information to:
            </p>
            <ul className="flex gap-2 flex-col pl-5">
              <li className="sm:text-md text-sm">
                - Improve and optimize our website.
              </li>
              <li className="sm:text-md text-sm">
                - Analyze how customers use our site.
              </li>
              <li className="sm:text-md text-sm">
                {" "}
                - Run marketing and advertising campaigns.
              </li>
            </ul>
          </div>
        </div>
        <div className="flex flex-col gap-5">
          <h3 className="font-bold">
            Sharing Your Information
          </h3>
          <div className="flex flex-col gap-3">
            <p className="sm:text-md text-sm">
              We share your information with third parties
              to help us use it as described above. For
              example:
            </p>
            <ul className="flex gap-2 flex-col pl-5">
              <li className="sm:flex gap-1 sm:text-md text-sm">
                <span>
                  - We use Google Analytics to understand
                  how customers use our site. You can opt
                  out of Google Analytics
                </span>
                <a
                  href="https://tools.google.com/dlpage/gaoptout"
                  className="underline sm:pl-0 pl-1"
                  target="_blank"
                  rel="noreferrer"
                >
                  here
                </a>
              </li>
              <li className="sm:text-md text-sm">
                - We may share your information to comply
                with laws or respond to legal requests.
              </li>
            </ul>
          </div>
        </div>
        <div className="flex flex-col gap-5">
          <h3 className="font-bold">Advertising</h3>
          <div className="flex flex-col gap-3">
            <p className="sm:text-md text-sm">
              We use your information to show you ads that
              might interest you. You can opt out of
              targeted ads using these links:
            </p>
            <p className="sm:text-md text-sm flex gap-2 flex-col pl-5">
              <a
                href="https://www.facebook.com/settings/?tab=ads"
                className="hover:underline flex gap-1 w-fit items-center"
                target="_blank"
                rel="noreferrer"
              >
                <span>- Facebook</span>
                <ExternalLinkIcon className="h-3 w-3" />
              </a>

              <a
                href="https://www.google.com/settings/ads/anonymous"
                className="hover:underline flex gap-1 w-fit items-center"
                target="_blank"
                rel="noreferrer"
              >
                <span>- Google</span>
                <ExternalLinkIcon className="h-3 w-3" />
              </a>

              <a
                href="https://advertise.bingads.microsoft.com/en-us/resources/policies/personalized-ads"
                className="hover:underline flex gap-1 w-fit items-center"
                target="_blank"
                rel="noreferrer"
              >
                <span>- Bing</span>
                <ExternalLinkIcon className="h-3 w-3" />
              </a>
            </p>
            <div className="flex gap-1 flex-wrap">
              <span className="text-sm sm:text-md w-100">
                You can also visit{" "}
              </span>{" "}
              <a
                href="http://optout.aboutads.info/"
                className="w-100 grow hover:underline flex gap-1 sm:w-fit text-sm sm:text-md items-center"
                target="_blank"
                rel="noreferrer"
              >
                the Digital Advertising Alliance's opt-out
                portal
                <ExternalLinkIcon className="h-3 w-3" />{" "}
              </a>
              <span className="text-sm sm:text-md w-100">
                {" "}
                to opt out of some services.
              </span>
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-5">
          <h3 className="font-bold">Your Rights</h3>
          <div className="flex flex-col gap-3">
            <p className="sm:text-md text-sm">
              If you're a European resident, you have the
              right to:
            </p>
            <p className="flex gap-2 flex-col pl-5 sm:text-md text-sm">
              <span>
                - Access, correct, update, or delete your
                personal information.
              </span>
              <span>
                - Object to how we use your information.
              </span>
            </p>
            <p className="sm:text-md text-sm">
              To exercise these rights, contact us using the
              information below.
            </p>
          </div>
        </div>
        <div className="flex flex-col gap-5">
          <h3 className="font-bold">Data Retention</h3>

          <p className="sm:text-md text-sm">
            We keep your Order Information for as long as
            necessary unless you ask us to delete it.
          </p>
        </div>
        <div className="flex flex-col gap-5">
          <h3 className="font-bold">
            Changes to This Policy
          </h3>

          <p className="sm:text-md text-sm">
            We may update this policy from time to time to
            reflect changes in our practices or for legal
            reasons.
          </p>
        </div>
        <div className="flex flex-col gap-5">
          <h3 className="font-bold">Contact Us</h3>
          <div className="flex flex-col gap-3">
            <p className="sm:text-md text-sm">
              If you have questions or concerns, contact us:
            </p>
            <p className="flex gap-2 flex-col pl-5">
              <a
                href="mailto:support@amadeussabra.com"
                className="hover:underline flex gap-1 w-fit items-center"
                target="_blank"
                rel="noreferrer"
              >
                <span>support@amadeussabra.com</span>
                <ExternalLinkIcon className="h-3 w-3" />
              </a>
              <a
                href="tel:+9613976780"
                className="hover:underline flex gap-1 w-fit items-center"
                target="_blank"
                rel="noreferrer"
              >
                <span>+961 3 976 780</span>
                <ExternalLinkIcon className="h-3 w-3" />
              </a>
            </p>
            <p className="sm:text-md text-sm">
              To exercise these rights, contact us using the
              information above.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
